import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    background: #080d12;
  }

  body {
    min-width: 320px;
    margin: 0;
    background: #080d12;
    color: #f6f8fb;
    font-family: "Segoe UI", Inter, Arial, sans-serif;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  button,
  input,
  textarea,
  select {
    font: inherit;
  }

  ::selection {
    color: #07110b;
    background: #55db87;
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: #34414c #0d141a;
  }

  *::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  *::-webkit-scrollbar-track {
    background: #0d141a;
  }

  *::-webkit-scrollbar-thumb {
    background: #34414c;
    border: 2px solid #0d141a;
    border-radius: 999px;
  }
`;

export default GlobalStyles;
